import { useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { X, Save } from "lucide-react";

export function BookingEdit({ booking, rooms, onClose, onDone }) {
  const [v, setV] = useState({ room_id: booking.room_id, title: booking.title, date: booking.date, start: booking.start, end: booking.end, series: false });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setV({ ...v, [k]: e.target.value });
  const save = async () => {
    setBusy(true);
    try {
      const r = await api.patch(`/room-bookings/${booking.id}`, v);
      const n = r.data.updated > 1 ? ` (${r.data.updated} semanas)` : "";
      toast.success(booking.status === "approved" ? `Marcação alterada${n}; os convidados recebem o novo dia e hora` : `Pedido alterado${n}; o aprovador foi avisado`);
      onDone();
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" onClick={onClose}>
      <div className="kw-card p-6 w-full max-w-md space-y-3" onClick={(e) => e.stopPropagation()} data-testid="booking-edit-modal">
        <div className="flex items-center justify-between">
          <div className="kw-overline">Editar marcação</div>
          <button onClick={onClose} data-testid="booking-edit-close"><X className="w-4 h-4" /></button>
        </div>
        <input className="kw-input w-full" value={v.title} onChange={set("title")} placeholder="Motivo" data-testid="booking-edit-title" />
        <select className="kw-input w-full" value={v.room_id} onChange={set("room_id")} data-testid="booking-edit-room">
          {rooms.map((r) => <option key={r.id} value={r.id}>{r.name} · {r.capacity} lugares</option>)}
        </select>
        <div className="grid grid-cols-3 gap-2">
          <input type="date" className="kw-input" value={v.date} onChange={set("date")} data-testid="booking-edit-date" />
          <input type="time" className="kw-input" value={v.start} onChange={set("start")} data-testid="booking-edit-start" />
          <input type="time" className="kw-input" value={v.end} onChange={set("end")} data-testid="booking-edit-end" />
        </div>
        {booking.series_id && (
          <label className="flex items-start gap-2 text-xs cursor-pointer" data-testid="booking-edit-series-label">
            <input type="checkbox" className="mt-0.5 accent-[#E50000]" checked={v.series}
              onChange={(e) => setV({ ...v, series: e.target.checked })} data-testid="booking-edit-series" />
            <span>Aplicar a <b>esta data e às seguintes</b> da recorrência. Se mudar o dia, todas avançam ou recuam o mesmo número de dias; as datas que já passaram ficam como estão.</span>
          </label>
        )}
        <button onClick={save} disabled={busy} className="kw-btn-primary w-full inline-flex items-center justify-center gap-2" data-testid="booking-edit-save">
          <Save className="w-4 h-4" /> {busy ? "A guardar…" : "Guardar alterações"}
        </button>
      </div>
    </div>
  );
}
